import { useState, useEffect, useRef, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { API_URL } from '../config';
import Spinner from '../components/Spinner';
import Footer from '../components/Footer';

export default function VerifyEmailPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');
  const [alreadyVerified, setAlreadyVerified] = useState(false);
  const hasVerified = useRef(false);

  const verifyEmail = useCallback(async () => {
    try {
      const response = await fetch(`${API_URL}/auth/verify-email/${token}`);
      const data = await response.json();

      console.log('Verification response:', { status: response.status, data });

      if (response.ok) {
        setSuccess(true);
        setMessage(data.message);
        setEmail(data.email);
        setAlreadyVerified(data.already_verified);
      } else {
        setSuccess(false);
        setMessage(data.detail || 'Verifica fallita');
      }
    } catch (error) {
      console.error('Verification error:', error);
      setSuccess(false);
      setMessage('Errore di connessione. Riprova più tardi.');
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    if (token && !hasVerified.current) {
      hasVerified.current = true;
      verifyEmail();
    }
  }, [token, verifyEmail]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <Spinner size="lg" color="blue" />
          <p className="text-xl" style={{ color: '#0E60C6' }}>Verifica in corso...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 flex flex-col p-4">
      <div className="flex-1 flex items-center justify-center">
        <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full">
        <div className="text-center mb-6">
          {success ? (
            <>
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-10 h-10" style={{ color: '#0E60C6' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h2 className="text-3xl font-bold text-gray-800 mb-2">
                {alreadyVerified ? 'Email già Verificata' : 'Email Verificata!'}
              </h2>
              <p className="text-gray-600 mb-4">{message}</p>
              {email && (
                <p className="text-sm text-gray-500 mb-6">
                  Account: <strong>{email}</strong>
                </p>
              )}
            </>
          ) : (
            <>
              <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-10 h-10 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </div>
              <h2 className="text-3xl font-bold text-gray-800 mb-2">Verifica Fallita</h2>
              <p className="text-gray-600 mb-6">{message}</p>
            </>
          )}
        </div>

        {success ? (
          <div className="space-y-3">
            <button
              onClick={() => navigate('/login')}
              className="w-full text-white py-3 rounded-lg transition font-medium"
              style={{ backgroundColor: '#0E60C6' }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#0B4FA3'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#0E60C6'}
            >
              Vai al Login
            </button>
            <p className="text-sm text-center text-gray-600">
              Ora puoi accedere con il tuo account verificato
            </p>
          </div>
        ) : (
          <button
            onClick={() => navigate('/')}
            className="w-full text-white py-3 rounded-lg transition font-medium"
            style={{ backgroundColor: '#0E60C6' }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#0B4FA3'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#0E60C6'}
          >
            Torna alla Home
          </button>
        )}
        </div>
      </div>

      <Footer />
    </div>
  );
}
